define('features/emailVerification/EmailVerificationDisplay',[],function() {

    function EmailVerificationDisplay(dialog, ErrorAlert, VerifyEmailAlert, getErrorField) {

        var self = this;

        self.showEmailVerificationError = function() {

            return dialog.showAlert(
                new ErrorAlert(
                    getErrorField('general_error_title'),
                    getErrorField('general_error_message')
                )
            );

        };

        self.showEmailVerification = function() {
            return dialog.showDialog(new VerifyEmailAlert());
        };

    }

    return EmailVerificationDisplay;

});

